export default () => ({
  handler: 'relativeUrl',
  data: ({ sportId, tabIndex }) => `/sports/${sportId}${Number.isInteger(tabIndex) ? `?tab=${tabIndex}` : ''}`,
});
